module.exports = __webpack_public_path__ + "static/assets/0bc337e42b7bc5a306df4dd8c1fcbe5a.svg";